export default __webpack_public_path__ + "static/media/manchester.8885144b.jpg";